import React from "react";
import { Box } from "@mui/system";

const ValueContainer = (props) => {
  const { children } = props;
  return (
    <Box
      className="flex flex-wrap flex-1 items-center  overflow-hidden"
      sx={{
        minHeight: "28px",
        position: "relative",
        "& div": {
          position: "absolute",
        },
      }}
    >
      {children}
    </Box>
  );
};

export default ValueContainer;
